

// export const getS3BaseUrl = () => {
//     const hostname = window.location.hostname;

//     if (hostname.includes('uat') || hostname === 'localhost' || hostname === '127.0.0.1') {
//         return 'https://inxits-uat-new.s3.ap-south-1.amazonaws.com/';
//     }
//     return 'https://inxits-prod-new.s3.ap-south-1.amazonaws.com/';
// }

const urls = {
    dev: "https://inxits-dev-new.s3.ap-south-1.amazonaws.com/",
    prod: "https://inxits-prod-new.s3.ap-south-1.amazonaws.com/",
    uat: "https://inxits-uat-new.s3.ap-south-1.amazonaws.com/"
}
const getS3BaseUrl = () => {
    const hostname = window.location.hostname;

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return urls.dev;
    }
    if (hostname.includes('uat')) {
        return urls.uat;
    }
    return urls.prod;
}

export const
    buildS3Url = (path) => {
        if (!path || !path.trim()) return null;

        if (path.startsWith("data:image")) return path;

        if (path.startsWith("http")) {
            const s3Regex = /https:\/\/inxits-[^.]+\.s3\.ap-south-1\.amazonaws\.com\/(.*)/;
            const match = path.match(s3Regex);
            if (match) return getS3BaseUrl() + match[1];
            return path; // non-S3 URL, as-is
        }

        return getS3BaseUrl() + path;
    }